export default __webpack_public_path__ + "static/skechers-24fbf72fae3fb75d6760897e6629186c.png";